module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon31.27f7b89a.png";